/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum CanonicalInterval {
  DAILY = 'daily',
  MONTHLY = 'monthly',
  ANNUALLY = 'annually',
  WEEKLY = 'weekly',
  ETERNAL = 'eternal',
}
